import { isTMA, LaunchParams, retrieveLaunchParams } from '@telegram-apps/sdk';
import axios, { AxiosRequestConfig } from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

let rawInitData: string | undefined;
let launchParams: LaunchParams | undefined;
// const isOpenedInTelegram = isTMA();

// Create an Axios instance (optional)
const api = axios.create({
  baseURL: API_BASE_URL, // Change this to your API base URL
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    if (true) {
      launchParams = launchParams ?? retrieveLaunchParams();
      config.headers['tdata'] = launchParams.initDataRaw;

      if (launchParams && launchParams.startParam) {
        const url = new URL(config.url!, API_BASE_URL);
        url.searchParams.append('ref', launchParams.startParam);

        config.url = url.toString();
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Generic GET request
export async function Get<T>(
  url: string,
  config?: AxiosRequestConfig,
): Promise<T | any> {
  try {
    const response = await api.get<T>(url, config);
    return response.data;
  } catch (error: any) {
    if (error.response?.data) {
      return error.response?.data;
    }
    return error;
  }
}

// Generic POST request
export async function Post<T, D>(
  url: string,
  data: D,
  config?: AxiosRequestConfig,
): Promise<T | any> {
  try {
    const response = await api.post<T>(url, data, config);
    return response.data;
  } catch (error: any) {
    if (error.response?.data) {
      return error.response?.data;
    }
    return error;
  }
}
function retrieveRawInitData(): string | undefined {
  throw new Error('Function not implemented.');
}
